import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../app/auth/auth.service';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { LocalService } from '../services/local.service';

export const loginRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const localService = inject(LocalService);

  const loginUser = localService.getJsonValue('loginUserData');
  return authService.user.pipe(
    take(1),
    map((user: any) => {
      const userData = JSON.stringify(user);
      if (user && loginUser && (userData === loginUser)) {
        return router.createUrlTree(['user/dashboard']);
      }
      return true;
    })
  );
};
